// extracted by mini-css-extract-plugin
export var anchor = "downloadableResource-module--anchor--38154";
export var aspectRatio = "downloadableResource-module--aspectRatio--d7344";
export var bodyText = "downloadableResource-module--bodyText--73f2e";
export var border = "downloadableResource-module--border--76dce";
export var button = "downloadableResource-module--button--4a5e7";
export var buttonText = "downloadableResource-module--buttonText--d36c4";
export var centerImage = "downloadableResource-module--centerImage--3be16";
export var description = "downloadableResource-module--description--195fa";
export var embededAsset = "downloadableResource-module--embededAsset--e0a37";
export var inner = "downloadableResource-module--inner--abb4c";
export var listItem = "downloadableResource-module--listItem--39b95";
export var section = "downloadableResource-module--section--96561";
export var table = "downloadableResource-module--table--e03c2";
export var tableHeader = "downloadableResource-module--tableHeader--cf272";
export var title = "downloadableResource-module--title--98129";